import { Loader2, CheckCircle2, AlertCircle, Clock } from "lucide-react";

const fmt = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("it-IT", {
      day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return "";
  }
};

export function SyncStatus({ state, testid = "sync-status" }) {
  if (!state) return null;
  const { running, status, last_sync } = state;

  let Icon = Clock;
  let cls = "text-muted-foreground";
  let text = "Mai sincronizzato";

  if (running) {
    Icon = Loader2;
    cls = "text-primary";
    text = "Sincronizzazione in corso…";
  } else if (status === "error") {
    Icon = AlertCircle;
    cls = "text-rose-400";
    text = `Ultima sincronizzazione fallita${last_sync ? ` · ${fmt(last_sync)}` : ""}`;
  } else if (last_sync) {
    Icon = CheckCircle2;
    cls = "text-emerald-400";
    text = `Ultima sincronizzazione: ${fmt(last_sync)}`;
  }

  return (
    <div className={`flex items-center gap-1.5 text-xs ${cls}`} data-testid={testid}>
      <Icon className={`h-3.5 w-3.5 ${running ? "animate-spin" : ""}`} />
      <span>{text}</span>
    </div>
  );
}
